/**
 * Landing Page
 * @author PBirudukota ROliver
 */
import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppDataService } from '../../services/app-data.service';
import {MessagesService} from '../../services/messages.service';
import {SalesrefService} from '../../services/salesref.service'
import { filter, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit, OnDestroy {

  enableActions: boolean = true;
  title: string = ' Application for Wholesale Purchasing Account';
  header: string = 'Please select what type of account you will be applying for';
  salesId: string
  destroy$ = new Subject<any>();

  constructor(
    private messagesService: MessagesService, 
    private router: Router,
    private route: ActivatedRoute,
    private salesrefservice: SalesrefService,
    private appDataService: AppDataService) {
    this.messagesService.sendBGMessage('yes');
    this.messagesService.sendLogoMessage('both');
  }

  ngOnInit() {
    this.referingSalesperson()
      if (this.salesId !== null) {
        this.validateSalesPerson(this.salesId);
      }

    this.getInfoBoxCopy();
  }


  getInfoBoxCopy() {
    this.appDataService.getDataByEleName("infoBox").pipe(
      takeUntil(this.destroy$),
      filter(res => res['isValid'] === true),
      tap(res => {
        this.appDataService.setAppData(true, res['result']);
      })
    ).subscribe()
  }


  referingSalesperson() {
    this.route.queryParams.pipe(
      takeUntil(this.destroy$),
      tap(params => {
        if(params['code']) {
          this.salesId = params['code']
        }
        else {
          this.salesId = null;
          this.salesrefservice.refinfo = {isValid: false, code: 0};
        }
      })).subscribe()
    }


  validateSalesPerson(salesId) {
    this.salesrefservice.lookupSalesId(salesId).pipe(
      takeUntil(this.destroy$),
      tap(res => {
        this.salesrefservice.refinfo = {isValid: res['isValid'], code: +this.salesId};
      })
    ).subscribe()
  }


ngOnDestroy() {
 this.destroy$.next(null);
}

}
